import axiosInstance from '../auth/axiosInstance';

const pickText = (...values) => {
  for (const value of values) {
    if (value != null && String(value).trim() !== '') {
      return String(value);
    }
  }
  return '';
};

const normalizeCompany = (company) => {
  if (!company || typeof company !== 'object') return company;
  return {
    ...company,
    industry: pickText(company.industry, company.Industry),
    companySize: pickText(company.companySize, company.CompanySize, company.company_size),
    engagementGoal: pickText(
      company.engagementGoal,
      company.EngagementGoal,
      company.engagement_goal
    ),
    additionalContext: pickText(
      company.additionalContext,
      company.AdditionalContext,
      company.additional_context
    ),
  };
};

export const getCompanyList = async (page, pageSize, sort = 'name-asc', search = '') => {
  try {
    console.log('Fetching company list...');
    const { data: result } = await axiosInstance.get('/Company/GetCompanies', {
      params: { pageNumber: page, pageSize, sort, search },
    });

    console.log('company list response:', result);
    if (
      result.data &&
      Array.isArray(result.data.items) &&
      typeof result.data.totalCount === 'number'
    ) {
      const { items, totalCount, pageNumber, pageSize: returnedSize } = result.data;
      return {
        items: items.map(normalizeCompany),
        totalCount,
        pageNumber,
        pageSize: returnedSize,
      };
    }

    console.error('Unexpected response structure:', result);
    return { items: [], totalCount: 0, pageNumber: page, pageSize };
  } catch (error) {
    console.error('Error fetching companies:', error);
    return { items: [], totalCount: 0, pageNumber: page, pageSize };
  }
};

export const addOrUpdateCompany = async (companyData) => {
  try {
    console.log('Adding/updating company with data:', companyData);
    const formattedData = {
      ...companyData,
      isActive: companyData.isActive ? 1 : 0,
    };

    console.log('Formatted data being sent to API:', formattedData);
    const { data: responseData } = await axiosInstance.post(
      '/Company/AddOrUpdateCompany',
      formattedData
    );

    console.log('AddOrUpdateCompany response:', responseData);
    if (responseData.data) {
      console.log('Returning company data:', responseData.data);
      return responseData.data;
    }

    console.error('Invalid response structure:', responseData);
    return {
      ...formattedData,
      id: formattedData.id || `temp-${Date.now()}`,
    };
  } catch (error) {
    console.error('Error during saving company:', error.message || error);
    throw error;
  }
};

export const deleteCompany = async (companyId) => {
  const { data: responseData } = await axiosInstance.post(
    `/Company/DeleteCompany/${companyId}`
  );

  const responseCode = responseData?.code ?? responseData?.Code;
  const failed =
    responseData?.data === false ||
    responseCode === 403 ||
    responseCode === 'Forbidden';

  if (failed) {
    const apiMessage = responseData?.message || responseData?.Message;
    throw new Error(apiMessage || 'Failed to delete company');
  }

  return responseData;
};
